import { getHealthMock } from '@amp/bff/partner/index.msw';

export const partnerHandlers = [...getHealthMock()];
